var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPagesWithTick = function SvgPagesWithTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pages-with-tick_svg__a",
    d: "M.221.054h10.19v31.458H.221z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.548 3.107)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pages-with-tick_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pages-with-tick_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.221.054 2.52 31.332c.012.154.23.173.269.024L10.41 2.68.221.054Z",
    fill: "#D5D8E0",
    mask: "url(#pages-with-tick_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D8E0",
    d: "m27.001.852-3.048.246L8.615 2.332l.318 3.973zM37.598 0l-8.42.678.388 1.29L40.363 37.75c.047.156.279.112.265-.05L37.833 2.935 37.598 0ZM32.906 36.992 21.214 40.54a.905.905 0 0 1-.524-1.731l11.69-3.545a.903.903 0 1 1 .526 1.728Zm-13.13-.648a.903.903 0 0 1-.262-1.77l11.69-3.548a.904.904 0 1 1 .524 1.73l-11.69 3.547a.894.894 0 0 1-.262.04Zm1.77-6.735 8.384-2.789a.904.904 0 0 1 .57 1.716l-8.382 2.788a.907.907 0 0 1-1.144-.572.903.903 0 0 1 .572-1.143Zm6.29-27.119L9.082 8.15 0 10.89l3.946 13.074c.714 0 1.41.278 1.98.807l2.915 2.768c1.995-5.882 4.375-10.845 6.82-14.19.454-.698 1.148-1.22 1.914-1.437 1.062-.303 2.102.01 2.712.81.613.801.628 1.868.048 2.862-2.89 5.386-4.556 11.033-5.567 18.877l-.07.554-.352.431c-.671.826-1.754 1.885-3.103 2.27-.994.282-1.984.14-2.786-.4l-.159-.107-.51-.51 3.57 11.833 27.835-8.4-.24-.796L27.836 2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.825 34.21c1.091-8.459 2.89-14.174 5.803-19.589.653-1.075-.741-1.159-1.349-.164-2.863 3.893-5.516 9.988-7.525 16.655l-5.121-4.868-.039-.036c-1.3-1.204-2.851 1.77-1.93 2.603l3.928 3.926 2.956 2.954c.931.623 2.262-.233 3.277-1.48",
    fill: "#D5D8E0"
  }))));
};
export default SvgPagesWithTick;